import React, { useRef, useState, useEffect } from 'react';
import Highlighter from 'react-highlight-words';
import { Button, Input, Space, Table } from 'antd';
import { SearchOutlined, DownloadOutlined } from '@ant-design/icons';
import './publikpengumuman.scss';
import AOS from 'aos';
import 'aos/dist/aos.css';
import axios from 'axios';
import { PuffLoader } from 'react-spinners';
import BASE_URL from '../../../../Util/config';

const PublikPengumumanMenuId = () => {
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 1300,
    });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${BASE_URL}/api/investors/public?remala`);

        if (response.status === 200 && response.data.success) {
          // Filter data berdasarkan kondisi baru:
          // 1. isActive === true
          // 2. approvalStatus === "published"
          // 3. informationTypeDetails.name === 'RUPS'
          const laporanItems = response.data.data
            .filter((item) => item.isActive === true && item.approvalStatus === 'published' && item.informationTypeDetails?.name === 'Pengumuman Publik')
            .sort((a, b) => {
              // Sort berdasarkan release_date descending (terbaru di atas)
              const dateA = new Date(a.release_date);
              const dateB = new Date(b.release_date);
              return dateB - dateA;
            })
            .map((item, index) => ({
              key: index + 1,
              judul: item.title_id,
              upload_file: `${BASE_URL}/${item.fileFilepath_id}`,
              metaTitle: item.metaTitle_id,
              slug: item.slug,
              releaseDate: item.release_date,
              createdAt: item.created_at,
              updatedAt: item.updated_at,
            }));
          setData(laporanItems);
        }
      } catch (error) {
        console.error('Terjadi kesalahan:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Cari
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Tutup
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  // Menambahkan kolom nomor urut
  const columns = [
    {
      title: 'No',
      dataIndex: 'key',
      key: 'key',
      width: '5%',
      render: (text) => <span>{text}</span>,
    },
    {
      title: 'Nama',
      dataIndex: 'judul',
      key: 'judul',
      ...getColumnSearchProps('judul'),
    },
    {
      title: 'Unduh',
      dataIndex: 'upload_file',
      key: 'upload_file',
      width: '10%',
      render: (text) => (
        <Button
          type="primary"
          icon={<DownloadOutlined />}
          size="small"
          onClick={() => {
            window.open(text, '_blank');
          }}
        >
          Unduh
        </Button>
      ),
    },
  ];

  return (
    <>
      <div className="mainContainerRups">
        {loading ? (
          <div className="loading-spinner-news">
            <PuffLoader color="#007bff" size={100} />
          </div>
        ) : (
          <>
            <div className="rupsTop" data-aos="fade-down">
              {/* <h4>Perusahaan telah membuat pengumuman mengenai Rapat Umum Pemegang Saham Tahunan (RUPST) setiap tahun sebagai berikut :</h4> */}
              <br />
              <h2>Pengumuman Publik</h2>
            </div>
            <hr />
            <div className="rupsBottom" data-aos="fade-left">
              <Table columns={columns} dataSource={data} pagination={{ pageSize: 5 }} />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default PublikPengumumanMenuId;
